import React from 'react';

import { Consolidation } from '@futrli-sdk/consolidations';
import { ListingPageRowActions } from '@futrli/ui-components/components/listing-page/listing-page-row/listing-page-row-actions/listing-page-row-actions';

import { useConsolidationActionItems } from '../../../../hooks/use-consolidation-action-items/use-consolidation-action-items';

interface ConsolidationRowActionsProps {
  consolidation: Consolidation;
}

export const ConsolidationRowActions = ({ consolidation }: ConsolidationRowActionsProps) => {
  const items = useConsolidationActionItems({ consolidation });

  return <ListingPageRowActions items={items} />;
};
